export default __webpack_public_path__ + "static/media/download-button.e6a1bc38.svg";